import { IconName, Space, Text } from '@billy/design-system'

import { ShortcutKey } from '../../../../ShortcutKey'
import { Translate } from '../../../../Translate'
import * as Styled from './styles'

interface ShortcutIconProps {
  icon?: IconName
  label?: string
}

interface ShortcutItemProps {
  icons?: ShortcutIconProps[]
  translationKey: string
}

export const ShortcutItem = ({ icons = [], translationKey }: ShortcutItemProps) => (
  <Styled.ShortcutItem>
    {icons.map((iconProps, idx) => (
      <ShortcutKey key={idx} {...iconProps} />
    ))}
    <Space size="s8" horizontal />
    <Text variant="bodySM" colorVariant="secondary">
      <Translate value={translationKey} />
    </Text>
  </Styled.ShortcutItem>
)
